import React,{useEffect, useState,useRef} from 'react';
import { DataTable } from 'primereact/datatable';
import { InputText } from 'primereact/inputtext';
import { Column } from "primereact/column";
import { Button } from 'primereact/button';
//import { classNames } from 'primereact/utils';
//import { IReembolso } from '../../../interfaces/IReembolso';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { ObtenerListaReembolso, filtrarListaReembolso, ConsultarTransacciones } from '../services/home.service';
//import { SUCCESS_LISTA_REEMBOLSO } from '../utilities/constants';
import { GetDateLocal } from '../../shared/utilitties/formatDate';
import { NumericFormat } from 'react-number-format';
import moment from 'moment';
import { FilterMatchMode } from 'primereact/api';

interface IState {
    loading: boolean,
    filterTable: any,
    filterTableOptions: any,
    reembolsos?: any[]
}

interface IProps {
}

const HistorialTablaReembolsos = (props: IProps) => {
    const [state,setState] = React.useState<IState>({
        loading: true,
        filterTable: 'En Proceso/Programados',
        filterTableOptions: [
            { value: 'En Proceso/Programados' },
            { value: 'Últimos 30 días' },
            { value: 'Últimos 90 días' }
        ]
    })
    const [reembolsos, setReembolsos] = useState<any[]>([])
    const [transacciones, setTransacciones] = useState<any[]>([])
    const [selectedItem,setSelectedItem] = useState<any>()
    const [visible, setVisible] = useState(false)
    const [visible_trx, setVisibleTrx] = useState(false)
    const [spinnerListaReembolso,setSpinnerListaReembolso] = useState(true)
    const [globalFilterValue, setGlobalFilterValue] = useState('')
    const dt = useRef<DataTable>(null);
    const [filters, setFilters] = useState({
        'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
    });

    useEffect(()=>{
        getListaReembolso();

    },[])

    const onGlobalFilterChange = (e:any) => {
        const value = e.target.value;
        let _filters = { ...filters };
        _filters['global'].value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    }

    const onFilterTable = (e: any) => {
        setState({ ...state, filterTable: e.value });

        fliterListaReembolso( e.value)
    }

    const getListaReembolso = async() => {
        const {data, status} = await ObtenerListaReembolso()
        if(status === 200){
            setReembolsos(data);
        }
        setSpinnerListaReembolso(false)

    }

    const fliterListaReembolso = async ( value: string) =>{
        let postData = { value: "" }

        if (value == 'En Proceso/Programados')
            postData.value = "1";
        if (value == 'Últimos 30 días')
            postData.value = "2";
        if (value == 'Últimos 90 días')
            postData.value = "3";

            const {data, status} = await filtrarListaReembolso(postData)
            if(status === 200){
                setReembolsos(data)
            }

                /*await fetch('api/Home/FiltrarListaReembolso', {
                    method: 'POST',
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(postData)
                }).then(function (response) {
                    return response.json();
                }).then(function (data: any) {
                    setReembolsos(data)
                });*/
    }

    const renderHeader = ()=> {
        return (
            <div className="row d-flex align-items-center">
                <div className="col">
                    <Button 
                        style={{color: 'white'}}
                        className='p-d-flex p-flex-row-reverse p-jc-around p-ai-center'
                        label="Exportar" 
                        onClick={exportCSV}>
                        <i className="pi pi-download p-mr-1" style={{fontSize: '1rem' }}></i>
                    </Button>
                </div>
                
                <div className="col d-flex align-items-center justify-content-end">
                    <p className="mr-2">Filtrar por:</p>
                    <Dropdown value={state.filterTable} options={state.filterTableOptions} onChange={onFilterTable} optionLabel="value" />
                </div>
                <div className="col d-flex align-items-center justify-content-end">
                    <p className="mr-2">Buscar por:</p>
                    <InputText value={globalFilterValue} onChange={onGlobalFilterChange} />
                </div>
            </div>
        );
    }

    const setValues = (item:any,val:boolean) => {
        setSelectedItem(item)
        setVisible(val)
    }

    const actionBodyTemplate = (item: any) => {
        return (
            <Button type="button" icon="pi pi-search" className="p-button-secondary" onClick={(e) =>setValues( item,  true )} tooltip="Detalle"></Button>
            // <Button type="button" icon="pi pi-search" className="p-button-secondary" onClick={() => console.log(item)}></Button>
        );
    }

    const fechaBodyTemplate = (rowData: any) => {
        return (        
        <React.Fragment>        
        <span className="p-column-title">Fecha</span>        
            {GetDateLocal(rowData.fechaPago)}        
         </React.Fragment>        
         );
    };

    const formatMoneyBodyTemplate = (rowData: any) => {
       return (
       <React.Fragment>        
         <NumericFormat
            value={rowData}
            displayType={"text"}
            thousandSeparator={"."}
            decimalSeparator={","}
            prefix={"$"}
            decimalScale={2}
            fixedDecimalScale={true}
        />
        </React.Fragment>
        );
    };
    
    const setValuesTrx = async (item: any, val: boolean) => {
        setSpinnerListaReembolso(true)
        const { data, status } = await ConsultarTransacciones(item.presentacion, item.productoId)
        if (status === 200) {
            setTransacciones(data);
        }
        setSpinnerListaReembolso(false)
        setVisibleTrx(val)
    }

    const actionViewTRXs = (item: any) => {
        return (
            <Button type="button" icon="pi pi-list" className="p-button-secondary" onClick={(e) => setValuesTrx(item, true)} tooltip="Transacciones"></Button>
        );
    }

    const GetFormatDate = (datedb: Date) => {
        let lastdate = new Date(datedb);
        let day = ('0' + lastdate.getDate().toString()).slice(-2);
        let month = lastdate.getMonth() + 1;
        let monthstring = ('0' + month.toString()).slice(-2);
        let year = lastdate.getFullYear().toString();
        let stringdate = day + '-' + monthstring + '-' + year;

        return stringdate;
    }

    const fechaTransacciones = (rowData: any) => {
        return (
            <React.Fragment>
                <span className="p-column-title">Fecha</span>
                {GetFormatDate(rowData.fecha_transaccion)}
            </React.Fragment>
        );
    };

    const vencidaTransacciones = (rowData: any) => {
        if (rowData.vencida) {
            return (
                <i className="pi pi-check-circle" style={{ color: 'red' }}></i>
            );
        }
    };

    const tcarCeroTransacciones = (tcar_cero: boolean) => {
        if (tcar_cero) {
            return (
                <i className="pi pi-check-circle" style={{ color: 'red' }}></i>
            );
        }
    };

    const totalesTransacciones = () => {
        const totalGeneral = transacciones.reduce((sum: number, rec: any) => sum + (rec.monto || 0), 0);
        const totalVencidas = transacciones.filter(({ vencida }) => vencida === true).reduce((sum: number, rec: any) => sum + (rec.monto || 0), 0)
        const totalTCarCero = transacciones.filter(({ tcar_cero }) => tcar_cero === true).reduce((sum: number, rec: any) => sum + (rec.monto || 0), 0)

        return (
            <div>
                <p>Total General: {formatMoneyBodyTemplate(totalGeneral)} - Total Vencidas: {formatMoneyBodyTemplate(totalVencidas)} - Total Red Cerrada: {formatMoneyBodyTemplate(totalTCarCero)}</p>
            </div>
        );
    }

    const tablaTransacciones = () => {
        return (
            <div>
                <div className="datatable-doc-demo">
                    <DataTable value={transacciones}
                        loading={spinnerListaReembolso}
                        responsiveLayout="stack" className="p-datatable-customers" dataKey="id" rowHover
                        paginator rows={10} emptyMessage="No se encontraron datos" currentPageReportTemplate="Mostrando del {first} a {last} de {totalRecords} registros"
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown" rowsPerPageOptions={[5, 10, 15]}
                        footer={totalesTransacciones}>
                        <Column body={fechaTransacciones} field="fecha_transaccion" header="Fecha" headerStyle={{ width: '10em', textAlign: 'left' }} bodyStyle={{ textAlign: 'left' }} />
                        <Column field="descripcion_producto" header="Solución" headerStyle={{ width: '20em', textAlign: 'left' }} bodyStyle={{ textAlign: 'left' }} />
                        <Column field="desc_producto" header="Producto" headerStyle={{ width: '20em', textAlign: 'left' }} bodyStyle={{ textAlign: 'left' }} />
                        <Column body={(rowdata) => formatMoneyBodyTemplate(rowdata.monto)} className="right" field="monto" header="Monto" headerStyle={{ width: '10em', textAlign: 'right' }} bodyStyle={{ textAlign: 'right' }} />
                        <Column body={vencidaTransacciones} field="vencida" header="Vencida" dataType="boolean" headerStyle={{ width: '8em', textAlign: 'center' }} bodyStyle={{ textAlign: 'center' }} />
                        <Column body={(rowdata) => tcarCeroTransacciones(rowdata.tcar_cero)} field="tcar_cero" header="Red Cerrada" dataType="boolean" headerStyle={{ width: '8em', textAlign: 'center' }} bodyStyle={{ textAlign: 'center' }} />
                    </DataTable>
                </div>
            </div>
        );
    };

    const dialogTransacciones = () => {
        if (transacciones) {
            return (
                <div>
                    {tablaTransacciones()}
                </div>
            );
        }
        else {
            return (
                <div></div>
            );
        }
    }

    const renderDialogContent = () => {

        if (selectedItem)  {
            console.log(selectedItem)
            const adelantoExpressLabel = ((selectedItem.adelantoExpress == "0,00") ? null : <label>Adelanto Express:</label>);
            const adelantoExpress = ((selectedItem.adelantoExpress == "0,00") ? null : <label>({selectedItem.adelantoExpress})</label>);
            return (
                <div>
                    <div className="card">
                        <div className="row p-0">
                            <div className="col">
                                <label>Razón Social:</label>
                            </div>
                            <div className="col">
                                <label>{selectedItem.razonSocial}</label>
                            </div>
                        </div>
                        <div className="row p-0">
                            <div className="col">
                                <label>Comercio:</label>
                            </div>
                            <div className="col">
                                <label>{selectedItem.comercio}</label>
                            </div>
                        </div>
                        <div className="row p-0">
                            <div className="col">
                                <label>Presentación:</label>
                            </div>
                            <div className="col">
                                <label>{selectedItem.presentacion}</label>
                            </div>
                        </div>
                        <div className="row p-0">
                            <div className="col">
                                <label>Fecha de Presentación:</label>
                            </div>
                            <div className="col">
                                <label>{moment(selectedItem.fechaPresentacion).format('DD/MM/YYYY')}</label>
                            </div>
                        </div>
                        <div className="row p-0">
                            <div className="col">
                                <label>Producto:</label>
                            </div>
                            <div className="col">
                                <label>{selectedItem.productoDesc}</label>
                            </div>
                        </div>
                        <div className="row p-0">
                            <div className="col">
                                <label>Fecha de Pago:</label>
                            </div>
                            <div className="col">
                                <label>{moment(selectedItem.fechaPago).format('DD/MM/YYYY')}</label>
                            </div>
                        </div>
                        <div className="row p-0">
                            <div className="col">
                                <label>Estado:</label>
                            </div>
                            <div className="col">
                                <label>{selectedItem.estadoReembolso}</label>
                            </div>
                        </div>
                        <div className="row p-0">
                            <div className="col">
                                <label>Pago:</label>
                            </div>
                            <div className="col">
                                <label>{selectedItem.Reembolso}</label>
                            </div>
                        </div>
                        <div className="row p-0">
                            <div className="col">
                                <label>Método:</label>
                            </div>
                            <div className="col">
                                <label>{selectedItem.metodoPagoDesc}</label>
                            </div>
                        </div>

                    </div>
                    <div className="card mt-2">
                        <h5 className="card-title">Composición de Pago</h5>
                        <div className="row">
                            <div className="col">
                                <label>Monto Bruto:</label>
                                <label>Cargos e Impuestos:</label>
                                {adelantoExpressLabel}
                                {
                                    selectedItem.debitos.map(function (item: any) {
                                        return (<label>{item.debitoEspecial + ": "}</label>)
                                    })
                                }
                                <label>Monto Neto:</label>
                            </div>
                            <div className="col" style={{ textAlign: 'right' }} >
                                <label>{selectedItem.monto}</label>
                                <label>({selectedItem.impuestos})</label>
                                {adelantoExpress}
                                {
                                    selectedItem.debitos.map(function (item: any) {
                                        let monto = (item.monto >= 0 ? item.monto :
                                            "(" + item.monto.toString().replace("-", "") + ")")
                                        return (<label>{monto}</label>)
                                    })
                                }
                                <label>{selectedItem.montoNeto}</label>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
        else {
            return (
                <div>
                </div>
            );
        }
    }

    const exportCSV = ()=> {
        dt.current!.exportCSV();
    }

    const header = renderHeader();

    return (
        <div>
            <div className="datatable-doc-demo">
                <DataTable ref={dt} value={reembolsos} csvSeparator=";"
                    loading={spinnerListaReembolso} filters={filters}
                    globalFilterFields={['presentacion', 'productoDesc', 'reembolso', 'monto','montoNeto','fechaPago','estadoReembolso']}
                    header={header} responsiveLayout="stack" className="p-datatable-customers" dataKey="id" rowHover
                    selection={selectedItem} onSelectionChange={e => setSelectedItem(e.value)}
                    paginator rows={10} emptyMessage="No customers found" currentPageReportTemplate="Mostrando del {first} a {last} de {totalRecords} registros"
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown" rowsPerPageOptions={[5, 10, 25, 50]}>
                    <Column field="presentacion" header="Presentación" headerStyle={{ width: '6em', textAlign: 'center' }} />
                    <Column field="productoDesc" header="Producto" headerStyle={{ width: '10em', textAlign: 'center' }} />
                    <Column body={fechaBodyTemplate} field="fechaPago" header="Fecha de Pago" className="right" headerStyle={{ width: '8em', textAlign: 'right' }} bodyStyle={{ textAlign: 'right' }} />
                    <Column body={(rowdata)=>formatMoneyBodyTemplate(rowdata.monto)} className="right" field ="monto" header="Monto Bruto" headerStyle={{ width: '6em', textAlign: 'right' }} bodyStyle={{ textAlign: 'right' }} />
                    <Column body={(rowdata)=>formatMoneyBodyTemplate(rowdata.montoNeto)} field="montoNeto" header="Monto Neto" className="right" headerStyle={{ width: '6em', textAlign: 'right' }} bodyStyle={{ textAlign: 'right' }} />
                    <Column field="estadoReembolso" header="Estado" headerStyle={{ width: '6em', textAlign: 'right' }} className="right" bodyStyle={{ textAlign: 'right' }} />
                    <Column body={(rowData) => actionViewTRXs(rowData)} headerStyle={{ width: '4em', textAlign: 'center' }} bodyStyle={{ textAlign: 'center', overflow: 'visible' }} />
                    <Column body={(rowData) => actionBodyTemplate(rowData)} headerStyle={{ width: '4em', textAlign: 'center' }} bodyStyle={{ textAlign: 'center', overflow: 'visible' }} />
                </DataTable>
            </div>
            <Dialog header="Detalle de Pago" visible={visible} className="detalle-reembolso" modal={true} onHide={() => setVisible(false)}>
                {renderDialogContent()}
            </Dialog>
            <Dialog header="Detalle de Transacciones Presentadas" visible={visible_trx} className="detalle-reembolso" modal={true} style={{ width: "75vw" }} onHide={() => setVisibleTrx(false)}>
                {dialogTransacciones()}
            </Dialog>
        </div>
  )
}
export default HistorialTablaReembolsos
